import React, { useState, useEffect } from 'react';

/**
 * Componente para optimizar imágenes con efecto de carga progresiva
 * @param {Object} props - Propiedades del componente
 * @param {string} props.src - Ruta de la imagen
 * @param {string} props.alt - Texto alternativo
 * @param {string} props.className - Clases adicionales
 * @param {Object} props.style - Estilos adicionales
 * @param {string} props.objectFit - Tipo de ajuste (cover, contain, etc.)
 * @param {boolean} props.priority - Si la imagen debe cargarse con prioridad
 */
const ImageOptimizer = ({ 
  src, 
  alt = "", 
  className = "", 
  style = {}, 
  objectFit = "cover",
  priority = false,
  ...props
}) => {
  const [loaded, setLoaded] = useState(false);
  const [, setError] = useState(false);

  // Función para forzar la carga de la imagen
  useEffect(() => {
    if (priority && src) {
      const img = new Image();
      img.src = src;
    }
  }, [src, priority]);

  // Manejar la carga de la imagen
  const handleLoad = () => {
    setLoaded(true);
  };

  // Manejar error de carga
  const handleError = () => {
    setError(true);
    console.error(`Error loading image: ${src}`);
  };

  return (
    <div className="relative w-full h-full overflow-hidden">
      {/* Contenedor para la imagen */}
      <div
        className={`absolute inset-0 bg-gray-200 transition-opacity duration-500 ${
          loaded ? 'opacity-0' : 'opacity-100'
        }`}
      />
      
      {/* Imagen real */}
      <img
        src={src}
        alt={alt}
        className={`w-full h-full transition-opacity duration-500 ${
          loaded ? 'opacity-100' : 'opacity-0'
        } ${className}`}
        style={{ 
          objectFit, 
          transform: 'translateZ(0)', 
          willChange: 'transform',
          imageRendering: 'auto',
          ...style 
        }}
        loading={priority ? "eager" : "lazy"}
        fetchpriority={priority ? "high" : "auto"}
        decoding="async"
        onLoad={handleLoad}
        onError={handleError}
        {...props}
      />
    </div>
  );
};

export default ImageOptimizer; 